import './style.css'
import {
  DisplayDateReportFormat,
  getBankName,
  getCreditCardRelationship
} from '../../helpers/texthelper'
import {
  calculateAgingDay,
  calculateAmount,
  getPaymentObjectivesType,
  getStatusDate
} from '../../helpers/reportHelper'

export const getRemark = (itemData: any): string => {
  if (itemData.remark != '') return itemData.remark
  return itemData.statusReason
}

export const ETRReport = (reportData: any) => {
  const rightNow = new Date()
  const csvData: any[] = []
  const rowHearder = new Array<any>(45)
  rowHearder.splice(0, 0, 'วันที่ดึงรายงาน')
  rowHearder.splice(1, 0, 'agentId')
  rowHearder.splice(2, 0, 'name')
  rowHearder.splice(3, 0, 'email')
  rowHearder.splice(4, 0, 'branchCode')
  rowHearder.splice(5, 0, 'branchName')
  rowHearder.splice(6, 0, 'receiptNo')
  rowHearder.splice(7, 0, 'payerName')
  rowHearder.splice(8, 0, 'insuredName')
  rowHearder.splice(9, 0, 'policyNo')
  rowHearder.splice(10, 0, 'planName')
  rowHearder.splice(11, 0, 'sumAssured')
  rowHearder.splice(12, 0, 'status')
  rowHearder.splice(13, 0, 'statusDate')
  rowHearder.splice(14, 0, 'statusUpdateBy')
  rowHearder.splice(15, 0, 'emailstatus')
  rowHearder.splice(16, 0, 'SMSstatus')
  rowHearder.splice(17, 0, 'referenceId')
  rowHearder.splice(18, 0, 'receiptdate')
  rowHearder.splice(19, 0, 'remark')
  rowHearder.splice(20, 0, 'canceldate')
  rowHearder.splice(21, 0, 'completedate')
  rowHearder.splice(22, 0, 'updateBy')
  rowHearder.splice(23, 0, 'customerMail')
  rowHearder.splice(24, 0, 'customerMailCore')
  rowHearder.splice(25, 0, 'customerPhone')
  rowHearder.splice(26, 0, 'customerPhoneCore')
  rowHearder.splice(27, 0, 'มีการเปลี่ยนแปลงอีเมลหรือเบอร์โทร')
  rowHearder.splice(28, 0, 'paymentFrequency')
  rowHearder.splice(29, 0, 'PayFor')
  rowHearder.splice(30, 0, 'PayForAmount')
  rowHearder.splice(31, 0, 'PayMethod')
  rowHearder.splice(32, 0, 'จำนวนเงิน(บาท)')
  rowHearder.splice(33, 0, 'รายละเอียดธนาคาร ')
  rowHearder.splice(34, 0, 'เลขที่บัญชี ')
  rowHearder.splice(35, 0, 'วันที่ฝาก')
  rowHearder.splice(36, 0, 'หมายเหตุ')
  rowHearder.splice(37, 0, 'PayMethod')
  rowHearder.splice(38, 0, 'จำนวนเงิน(บาท)')
  rowHearder.splice(39, 0, 'ธนาคาร')
  rowHearder.splice(40, 0, 'สาขา')
  rowHearder.splice(41, 0, 'เลขที่เช็ค')
  rowHearder.splice(42, 0, 'ลงวันที่')
  rowHearder.splice(43, 0, 'จำนวนเงินตามหน้าเช็ค')
  rowHearder.splice(44, 0, 'รายละเอียดธนาคาร ')
  rowHearder.splice(45, 0, 'เลขที่บัญชี ')
  rowHearder.splice(46, 0, 'วันที่ฝาก')
  rowHearder.splice(47, 0, 'หมายเหตุ')
  rowHearder.splice(48, 0, 'PayMethod')
  rowHearder.splice(49, 0, 'จำนวนเงิน(บาท)')
  rowHearder.splice(50, 0, 'ชื่อเจ้าของบัตรเครดิต')
  rowHearder.splice(51, 0, 'เจ้าของบัตรเครดิตมีความสัมพันธ์เป็นอะไรกับผู้เอาประกันภัย')
  rowHearder.splice(52, 0, 'ประเภทบัตร')
  rowHearder.splice(53, 0, 'เลขที่บัตร')
  rowHearder.splice(54, 0, 'วันที่หมดอายุ')
  rowHearder.splice(55, 0, 'ลงวันที่')
  rowHearder.splice(56, 0, 'วันที่อนุมัติ ')
  rowHearder.splice(57, 0, 'รหัสอนุมัติ')
  rowHearder.splice(58, 0, 'หมายเหตุ')
  rowHearder.splice(59, 0, 'PayMethod')
  rowHearder.splice(60, 0, 'จำนวนเงิน(บาท)')
  rowHearder.splice(61, 0, 'ธนาคาร')
  rowHearder.splice(62, 0, 'เลขที่บัญชี ')
  rowHearder.splice(63, 0, 'วันที่ฝาก')
  rowHearder.splice(64, 0, 'หมายเหตุ')
  rowHearder.splice(65, 0, 'PayMethod')
  rowHearder.splice(66, 0, 'จำนวนเงิน(บาท)')
  rowHearder.splice(67, 0, 'ธนาคาร')
  rowHearder.splice(68, 0, 'สาขา')
  rowHearder.splice(69, 0, 'เลขที่เช็ค')
  rowHearder.splice(70, 0, 'ลงวันที่')
  rowHearder.splice(71, 0, 'รายละเอียดธนาคาร')
  rowHearder.splice(72, 0, 'เลขที่บัญชี')
  rowHearder.splice(73, 0, 'วันที่ฝาก')
  rowHearder.splice(74, 0, 'จำนวนเงินตามหน้าเช็ค')
  rowHearder.splice(75, 0, 'หมายเหตุ')
  rowHearder.splice(76, 0, 'PayMethod')
  rowHearder.splice(77, 0, 'จำนวนเงิน(บาท)')
  rowHearder.splice(78, 0, 'เลขที่เช็ค')
  rowHearder.splice(79, 0, 'ลงวันที่')
  rowHearder.splice(80, 0, 'หมายเหตุ')
  rowHearder.splice(81, 0, 'PayMethod')
  rowHearder.splice(82, 0, 'จำนวนเงิน(บาท)')
  rowHearder.splice(83, 0, 'รายละเอียดธนาคาร ')
  rowHearder.splice(84, 0, 'เลขที่บัญชี ')
  rowHearder.splice(85, 0, 'วันที่ฝาก')
  rowHearder.splice(86, 0, 'หมายเหตุ')
  rowHearder.splice(87, 0, 'PayMethod')
  rowHearder.splice(88, 0, 'จำนวนเงิน(บาท)')
  rowHearder.splice(89, 0, 'หมายเหตุ')
  rowHearder.splice(90, 0, 'Aging (จำนวนวันนับจากวันที่ออก e-TR)')
  rowHearder.splice(91, 0, 'เหตุผลที่ส่งงานล่าช้า')
  csvData.push(rowHearder)
  const createCSVData = () => {
    reportData.data &&
      reportData.data.forEach((item: any) => {
        const rowData = new Array<any>(45)
        rowData[0] = DisplayDateReportFormat(new Date())
        rowData[1] = item.agent.agentId
        rowData[2] = item.agent.name
        rowData[3] = item.agent.email
        rowData[4] = item.agent.branchCode
        rowData[5] = item.agent.branchName
        rowData[6] = item.receiptNo
        rowData[7] = item.payerName
        rowData[8] = item.insuredName
        rowData[9] = item.policyNo
        rowData[10] = item.planName
        rowData[11] = item.sumAssured
        rowData[12] = item.status
        rowData[13] = DisplayDateReportFormat(getStatusDate(item))
        rowData[14] = item.updateBy
        rowData[15] = item.emailstatus
        rowData[16] = item.SMSstatus
        rowData[17] = item.referenceId
        rowData[18] = DisplayDateReportFormat(item.receiptdate)
        rowData[19] = getRemark(item)
        rowData[20] = DisplayDateReportFormat(item.canceldate)
        rowData[21] = DisplayDateReportFormat(item.statusDate)
        rowData[22] = item.updateBy
        rowData[23] = item.customerMail
        rowData[24] = item.customerMailCore
        rowData[25] = item.customerPhone
        rowData[26] = item.customerPhoneCore
        rowData[27] = item.hasChangeEmailOrMobile ? 'มี' : ''
        rowData[28] = item.paymentFrequency
        rowData[29] = getPaymentObjectivesType(item.paymentObjectives)
        rowData[30] = calculateAmount(item.paymentObjectives)
        item.documentDetails.forEach((dt: any) => {
          switch (dt.paymentMethod.id) {
            case 1:
              rowData[31] = dt.paymentMethod.name
              rowData[32] = dt.paymentAmount
              rowData[33] = getBankName(dt.bankCode)
              rowData[34] = dt.accountNo
              rowData[35] = DisplayDateReportFormat(dt.payInDate)
              rowData[36] = dt.remarkMoneyType
              break
            case 2:
              rowData[37] = dt.paymentMethod.name
              rowData[38] = dt.paymentAmount
              rowData[39] = dt.cheque_Bank
              rowData[40] = dt.cheque_Branch
              rowData[41] = dt.cheque_Number
              rowData[42] = DisplayDateReportFormat(dt.cheque_Date)
              rowData[43] = dt.paymentTotalAmount
              rowData[44] = getBankName(dt.bankCode)
              rowData[45] = dt.accountNo
              rowData[46] = DisplayDateReportFormat(dt.payInDate)
              rowData[47] = dt.remarkMoneyType
              break
            case 3:
              rowData[48] = dt.paymentMethod.name
              rowData[49] = dt.paymentAmount
              rowData[50] = dt.creditCard_HolderName
              rowData[51] = getCreditCardRelationship(dt.creditCard_HolderRelationship)
              rowData[52] = dt.creditCard_Type
              rowData[53] = dt.creditCard_Number
              rowData[54] = dt.creditCard_ExpDate
              rowData[55] = DisplayDateReportFormat(dt.creditCard_SignDate)
              rowData[56] = DisplayDateReportFormat(dt.creditCard_ApprovalDate)
              rowData[57] = dt.creditCard_ApprovalCode
              rowData[58] = dt.remarkMoneyType
              break
            case 4:
              rowData[87] = dt.paymentMethod.name
              rowData[88] = dt.paymentAmount
              rowData[89] = dt.other_Pay
              break
            case 5:
              rowData[59] = dt.paymentMethod.name
              rowData[60] = dt.paymentAmount
              rowData[61] = getBankName(dt.bankCode)
              rowData[62] = dt.accountNo
              rowData[63] = DisplayDateReportFormat(dt.payInDate)
              rowData[64] = dt.remarkMoneyType
              break
            case 6:
              rowData[65] = dt.paymentMethod.name
              rowData[66] = dt.paymentAmount
              rowData[67] = dt.cheque_Bank
              rowData[68] = dt.cheque_Branch
              rowData[69] = dt.cheque_Number
              rowData[70] = DisplayDateReportFormat(dt.cheque_Date)
              rowData[71] = getBankName(dt.bankCode)
              rowData[72] = dt.accountNo
              rowData[73] = DisplayDateReportFormat(dt.payInDate)
              rowData[74] = dt.paymentTotalAmount
              rowData[75] = dt.remarkMoneyType

              break
            case 7:
              rowData[76] = dt.paymentMethod.name
              rowData[77] = dt.paymentAmount
              rowData[78] = dt.cheque_Number
              rowData[79] = DisplayDateReportFormat(dt.cheque_Date)
              rowData[80] = dt.remarkMoneyType

              break
            case 8:
              rowData[81] = dt.paymentMethod.name
              rowData[82] = dt.paymentAmount
              rowData[83] = getBankName(dt.bankCode)
              rowData[84] = dt.accountNo
              rowData[85] = DisplayDateReportFormat(dt.payInDate)
              rowData[86] = dt.remarkMoneyType
              break
            default:
              break
          }
        })
        rowData[90] = calculateAgingDay(item)
        rowData[91] = item.submissionDelayReason
        csvData.push(rowData)
      })
    //setCsvResult(csvData)
    return csvData
  }

  return createCSVData()
}
